import { memo } from "react";
import styled from "styled-components";

export interface DateRainbowTier {
  label: string;
  subLabel: string;
  color: string;
  daysMax?: number; // in days
}

export const DATE_RAINBOW_TIERS: DateRainbowTier[] = [
  { label: "Trong 24 giờ qua", subLabel: "< 1 ngày (Mới nhất)", color: "#8b5cf6", daysMax: 1 },
  { label: "1 - 3 ngày trước", subLabel: "Gần đây", color: "#3b82f6", daysMax: 3 },
  { label: "3 - 7 ngày trước", subLabel: "Trong tuần", color: "#10b981", daysMax: 7 },
  { label: "1 - 2 tuần trước", subLabel: "2 tuần qua", color: "#eab308", daysMax: 14 },
  { label: "2 - 4 tuần trước", subLabel: "Trong tháng", color: "#f97316", daysMax: 30 },
  { label: "Trên 1 tháng trước", subLabel: "Cũ nhất", color: "#ef4444" },
];

const DateRainbowTab = () => {
  return (
    <Container>
      <DescriptionBox>
        <span>
          Dữ liệu thu thập sẽ được tô màu dạng dải quang phổ (Rainbow) theo thời điểm thu thập. Dữ liệu mới nhất sẽ có màu tím/lam và dần chuyển sang lục, vàng, cam, đỏ đối với dữ liệu cũ hơn.
        </span>
      </DescriptionBox>

      <GradientPreviewContainer>
        <GradientLabelRow>
          <span>Mới nhất (&lt; 24h)</span>
          <span>Cũ nhất (&gt; 1 tháng)</span>
        </GradientLabelRow>
        <GradientBar />
      </GradientPreviewContainer>

      <TierList>
        {DATE_RAINBOW_TIERS.map((tier, idx) => (
          <TierRow key={idx}>
            <TierColorSwatch style={{ backgroundColor: tier.color }} />
            <TierLabelContainer>
              <TierLabel>{tier.label}</TierLabel>
              <TierSubLabel>{tier.subLabel}</TierSubLabel>
            </TierLabelContainer>
            <ColorHexBadge>{tier.color.toUpperCase()}</ColorHexBadge>
          </TierRow>
        ))}
      </TierList>
    </Container>
  );
};

export default memo(DateRainbowTab);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 12px 0;
`;

const DescriptionBox = styled.div`
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  color: #1e40af;
  line-height: 1.5;
`;

const GradientPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
`;

const GradientLabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
`;

const GradientBar = styled.div`
  height: 14px;
  border-radius: 7px;
  background: linear-gradient(
    to right,
    #8b5cf6 0%,
    #3b82f6 20%,
    #10b981 40%,
    #eab308 60%,
    #f97316 80%,
    #ef4444 100%
  );
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);
`;

const TierList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TierRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
`;

const TierColorSwatch = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
`;

const TierLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 12px;
`;

const TierLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
`;

const TierSubLabel = styled.span`
  font-size: 12px;
  color: #64748b;
`;

const ColorHexBadge = styled.span`
  font-family: monospace;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
`;
